// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  border-radius: 50%;
  border: 1px solid transparent;
  text-align: center;
  cursor: pointer;
  color: #FDFBFB;
  background: #1DADB5;
}
.btn.btn-size1 {
  height: 1.25rem;
  border-radius: 0.625rem;
}
.btn.btn-size1.btn-icon {
  width: 1.25rem;
}
.btn.btn-size2 {
  height: 1.875rem;
  line-height: 1.875rem;
  border-radius: 0.9375rem;
}
.btn.btn-size2.btn-icon {
  width: 1.875rem;
}
.btn.btn-size3 {
  height: 2.1rem;
  border-radius: 1.05rem;
  font-size: 0.9rem;
  line-height: 1.95rem;
  border-width: 2px;
}
.btn.btn-size3.btn-icon {
  width: 2.1rem;
}
.btn.btn-size3 i {
  font-weight: 600;
}
.btn.btn-white {
  border-color: #1DADB5;
  background: #FDFBFB;
  color: #1DADB5;
}
.btn.btn-white-dark {
  border-color: #00666F;
  background: #FDFBFB;
  color: #00666F;
}

.btn-list .btn {
  margin: 0 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/Button.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAIA;EACI,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EAqCA,cCpCW;EDqCX,mBC7Ba;ADVjB;AAGI;EAEI,eAAA;EACA,uBAAA;AAFR;AAGQ;EACI,cAAA;AADZ;AAMI;EACI,gBAAA;EACA,qBAAA;EACA,wBAAA;AAJR;AAKQ;EACI,eAAA;AAHZ;AAOI;EACI,cAAA;EACA,sBAAA;EAKA,iBAAA;EACA,oBAAA;EACA,iBAAA;AATR;AAGQ;EACI,aAAA;AADZ;AAQQ;EACI,gBAAA;AANZ;AAaI;EACI,qBChCS;EDkCT,mBC1CO;ED2CP,cCnCS;ADuBjB;AAeI;EACI,qBCrCc;EDsCd,mBChDO;EDiDP,cCvCc;AD0BtB;;AAmBI;EACI,gBAAA;AAhBR","sourcesContent":["@use './abstracts/variables' as *;\n@use './abstracts/functions';\n\n\n.btn {\n    border-radius: 50%;\n    border: 1px solid transparent;\n    text-align: center;\n    cursor: pointer;\n\n    &.btn-size1 {\n\n        height: 1.25rem;\n        border-radius: 0.625rem;\n        &.btn-icon {\n            width: 1.25rem;\n            \n        }\n    }\n\n    &.btn-size2 {\n        height: 1.875rem;\n        line-height: 1.875rem;\n        border-radius: 0.9375rem;\n        &.btn-icon {\n            width: 1.875rem;\n        }\n    }\n\n    &.btn-size3 {\n        height: 2.1rem;\n        border-radius: 1.05rem;\n        &.btn-icon {\n            width: 2.1rem;\n        }\n\n        font-size: 0.9rem;\n        line-height: 1.95rem;\n        border-width:2px;\n\n        i {\n            font-weight: 600;\n        }\n    }\n\n    color:$color__white;\n    background: $color__primary;\n\n    &.btn-white {\n        border-color: $color__primary;\n        ;\n        background: $color__white;\n        color: $color__primary;\n    }\n\n    &.btn-white-dark {\n        border-color: $color__primary-dark;\n        background: $color__white;\n        color: $color__primary-dark;\n\n    }\n}\n\n.btn-list {\n    .btn {\n        margin: 0 0.2rem;\n    }\n}","// Screen sizes\n$screen-sm: 576px;\n$screen-md: 768px;\n$screen-lg: 992px;\n$screen-xl: 1200px;\n$screen-xxl: 1440px;\n$screen-full: 1920px;\n\n// Colors\n$color__white: #FDFBFB;\n$color__red: #FF4958;\n$color__orange: #F4981C;\n$color__black: #000000;\n$color_grey: #EEE7E1;\n$color-darkgrey: #697F8C;\n\n\n$color__primary: #1DADB5;\n$color__primary-alt: #007E94;\n$color__primary-dark: #00666F;\n$color__primary-light: #D3F1F2;\n\n$color__secondary-dark: #7D748D;\n$color__secondary: #ACA6B7;\n$color__secondary-light1: #E8E5EC;\n$color__secondary-light2: #F6F5F8;\n\n\n$color__ternary: #333c50;\n\n$theme__colors: (\n    \"primary\": $color__primary, \n    \"dark\": $color__black, \n    \"danger\": $color__red, \n    \"warning\": $color__orange\n);\n\n$font__primary: 'Exo', sans-serif;\n$font__secondary: 'Inter', sans-serif;\n\n$font__ternary: 'Filson Pro', sans-serif;\n$font__quaternary: 'Omnes', sans-serif;\n\n$size__text: 1rem;\n\n$font__text: $font__primary;\n$font__title: $font__primary;\n\n$border-radius1 : 10px;\n$border-radius2 : 15px;\n$border-radius3 : 20px;\n\n$marge1:5px;\n$marge2:10px;\n$marge3:5px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
